import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import trailersHeaders from "@/pages/Maintenance/Trailers/trailersHeaders";

export default {
	state: {
		trailersItem: null,
		trailersList: null,
		trailersFilters: null,
		trailersTotals: null,
		trailersLimit: null,
		trailersOrder: null,
		trailersSort: null,
		trailersTotal: null,
	},
	mutations: {
		updateTrailersList(state, { rows, limit, order, sort, total }) {
			state.trailersList = rows;
			state.trailersLimit = limit;
			state.trailersOrder = order;
			state.trailersSort = sort;
			state.trailersTotal = total;
			state.trailersTotals = { id: total };
		},
		updateTrailersFilters(state, { filter }) {
			state.trailersFilters = filter;
		},
		updateTrailers(state, payload) {
			state.trailersItem = payload;
		}
	},
	actions: {

		async getTrailers({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/trailers/list', values);

				if (data && !data.status) {
					commit('updateTrailersList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.TRUCKS, defaultHeader: trailersHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getTrailersFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/trailers/filters', values);
				if (data) commit('updateTrailersFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onTrailersCreate({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			const url = id ? `/trailers/create?customer_id=${ id }` : "/trailers/create";
			try {
				const { data } = await httpClient.get(url);
				if (data && !data.error) {
					if (id) {
						return data;
					}
					commit('updateTrailers', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrailersHistory({ dispatch }, history) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/trailers/updateTruckCustomer', { history });
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrailersSave({ dispatch }, { values, trailer_id }) {
			dispatch("actionPreloader", true);
			const typeOfRequest = trailer_id ? 'put' : 'post';
			const url = trailer_id ? `/trailers/${ trailer_id }` : '/trailers';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrailersEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/trailers/${ id }/edit`);

				if (data && !data.error) {
					commit('updateTrailers', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrailersRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/trailers/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			}
		},

		async getTrailersComments({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/trailers/description/${ id }`);
				if (data && !data.status) return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
	},
	getters: {
		trailersItem: (s) => s.trailersItem,
		trailersList: (s) => s.trailersList,
		trailersFilters: (s) => s.trailersFilters,
		trailersTotals: (s) => s.trailersTotals,
		trailersLimit: (s) => s.trailersLimit,
		trailersOrder: (s) => s.trailersOrder,
		trailersSort: (s) => s.trailersSort,
		trailersTotal: (s) => s.trailersTotal,
	}
};
